<template>
  <div>
    <component ref="fadeContain" v-on:fade="fadeText($event[0], $event[1])" v-bind:class="{ noSwipe: isNoSwipe }" v-on:transitionrun.native="swiped" v-on:touchstart.native="swiped" v-on:touchend.native="release" v-on:transitionend.native="release" :is="component" v-if="component"/>
    <button @click="toggleFade" id="swapText" ref="swapText" class="button" v-if="isNoSwipe"><img src="@/assets/img/Arrows_2.png" class="hidden"><img src="@/assets/img/Arrows_rev_2.png"></button>
  </div>
</template>

<script>
import { updateProgress } from '@/firebaseService.js'
export default {
  name: 'DynamicStory',
  props: {
    story: String,
    episode: String,
    chapter: String
  },
  data () {
    return {
      component: null,
      preventRemoveMove: true,
      swiping: false
    }
  },
  methods: {
    updateTitle (e) {
      this.$store.commit('titleUpdate', e)
    },
    swiped () {
      if (!this.isNoSwipe) {
        if (!this.swiping) {
          this.preventRemoveMove = true
          var el = this.$refs.fadeContain.$children[0].$refs['VueCarousel-inner']
          el.classList.add('moving')
          setTimeout(() => { if (this.swiping) { this.preventRemoveMove = false; this.swiping = false } }, 700)
        }
        this.swiping = true
      }
    },
    release () {
      if (!this.isNoSwipe) {
        var el = this.$refs.fadeContain.$children[0].$refs['VueCarousel-inner']
        const removeInt = setInterval(() => {
          if (this.preventRemoveMove === false && this.swiping === false) {
            el.classList.remove('moving')
            this.preventRemoveMove = true
            clearInterval(removeInt)
          }
        },
        100)
      }
    },
    toggleFade () {
      this.$refs.fadeContain.$refs.story1.classList.toggle('active')
      this.$refs.fadeContain.$refs.story1.classList.toggle('hidden')
      this.$refs.fadeContain.$refs.story2.classList.toggle('hidden')
      this.$refs.fadeContain.$refs.story2.classList.toggle('active')
      this.$refs.swapText.children[0].classList.toggle('hidden')
      this.$refs.swapText.children[1].classList.toggle('hidden')
      document.activeElement.blur()
    },
    fadeText (target, speed) {
      const speeds = {
        slow: 5000,
        normal: 3500,
        fast: 2000
      }
      this.$refs.fadeContain.$refs[target].style.transition = 'opacity ' + speeds[speed] + 'ms ease'
      this.$refs.fadeContain.$refs[target].style.opacity = '0'
      if (this.$route.params.example !== true) {
        const newFades = this.$root.progress.fades
        if (!newFades.includes(target)) {
          newFades.push(target)
          setTimeout(() => { updateProgress({ fades: newFades }) }, speeds[speed])
        }
      }
    },
    hideFaded () {
      for (const key in this.$refs.fadeContain.$refs) {
        if (this.$root.progress.fades.indexOf(key) >= 0) {
          this.$refs.fadeContain.$refs[key].style.visibility = 'hidden'
        }
      }
    }
  },
  computed: {
    loader () {
      if (!this.story || !this.episode || !this.chapter) {
        return null
      }
      return () => import('./episodes/' + this.episode + '/chapters/' + this.chapter + '/stories/' + this.story + '.vue')
    },
    isNoSwipe () {
      if (this.episode === '3') {
        return true
      }
      return false
    }
  },
  mounted () {
    this.loader()
      .then(() => {
        this.component = () => this.loader()
      })
      .catch(() => {
        this.component = () => import('../views/StoryViewer.vue')
      })
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  updated () {
    if (this.$route.params.example !== true) {
      this.hideFaded()
    }
  }
}
</script>

<style lang="css">
.VueCarousel-pagination {
  position: fixed;
  bottom: 3px;
  z-index: 100;
  pointer-events: none;
}
.VueCarousel-dot-container {
  pointer-events: auto;
}
.VueCarousel-dot{
}
.VueCarousel-slide {
  overflow-y: scroll;
  text-align: left;
  font-family: 'Georgia', serif;
  /*border-left: 1px solid;
  border-right: 1px solid;
  border-image-source:
    radial-gradient(
      rgba(74, 74, 74, 0.5) 2%,
      rgba(0, 0, 0, 0) 50%
    );
  /*border-image-outset: 3rem;
  border-image-slice: 5% 0% 15% 50%;
  border-image-width: 3rem;*/
  /*border-image-outset: 3rem;
  border-image-slice: 5% 100% 15% 0%;
  border-image-width: 6rem;*/
}
.VueCarousel-slide:first-child {
  border-left: none;
  border-image-slice: 5% 100% 15% 0%;
  /*border-image-slice: 5% 0% 15% 0%;*/
}
.VueCarousel-slide:last-child {
  border-left: none;
  border-image-slice: 0% 0% 0% 0%;
}
.noSwipe {
  overflow: visible;
  height: calc(100vh - 60px - 49px);
  height: calc((var(--vh, 1vh) * 100) - 60px - 49px);
  position: relative;
}
.noSwipe .VueCarousel-slide {
  border: none;
  position: absolute;
  transition: opacity 1s ease;
}
.noSwipe .VueCarousel-slide .arch {
  text-align: right;
}
.noSwipe .VueCarousel-slide.active {
  opacity: 1;
  touch-action: auto;
  pointer-events: auto;
}
.noSwipe .VueCarousel-slide.hidden {
  opacity: 0;
  touch-action: none;
  pointer-events: none;
}
.VueCarousel-inner.moving .VueCarousel-slide {
  border-color: rgba(0,0,0,0);
  border-image-source: none;
}
#swapText {
  position: fixed;
  bottom:10px;
  right: 16px;
  width: 80px;
  z-index: 9999;
}
#swapText img {
  position: absolute;
  height: 90%;
  left:0;
  right: 0;
  margin: auto;
  transition: opacity 1s ease;
  opacity: 1;
}
#swapText img:focus {
outline-width: 0;
}
#swapText img.hidden {
  opacity: 0;
}
</style>
<style type="text/css" scoped>
  /deep/ .VueCarousel-slide {
    height: calc(100vh - 60px - 3rem);
    height: calc((var(--vh, 1vh) * 100) - 60px - 3em);
  }
  /deep/ .VueCarousel-dot-container {
    display: flex !important;
    flex-wrap: wrap;
    justify-content: center;
    margin-left: 100px !important;
    margin-right: 50px !important;
  }
  /deep/ .VueCarousel-dot{
    padding: 8px 8px !important;
    margin-top: auto !important;
  }
</style>
